export interface Chateau {
  nom: string;
  photo: string;
  largeur: number;
  longueur: number;
  description: string;
  prixDemiJournee: number;
  prixJournee: number;
}

// Liste unique, utilisée par le catalogue et par le carrousel de l'accueil.
export const CHATEAUX: Chateau[] = [
  {
    nom: 'Western',
    photo: 'images/chateaux/western-farino.jpg',
    largeur: 5.5,
    longueur: 5.5,
    description: 'Plongez dans l’univers des cow-boys et des indiens avec notre château gonflable Western !',
    prixDemiJournee: 20000,
    prixJournee: 27000,
  },
  {
    nom: 'Barbie',
    photo: 'images/chateaux/barbie.jpg',
    largeur: 6.5,
    longueur: 6.5,
    description: 'Un château gonflable ultra-girly aux couleurs de Barbie : rose étincelant, paillettes et ambiance magique ! Parfait pour les anniversaires de princesse !',
    prixDemiJournee: 23000,
    prixJournee: 30000,
  },
  {
    nom: 'Dinosaure',
    photo: 'images/chateaux/dinosaure.jpg',
    largeur: 4.5,
    longueur: 4.5,
    description: 'Un château gonflable sur le thème des dinosaures avec un grand toboggan pour des heures d’aventure !',
    prixDemiJournee: 18000,
    prixJournee: 25000,
  },
  {
    nom: 'Disney',
    photo: 'images/chateaux/disney.jpg',
    largeur: 4.5,
    longueur: 4.5,
    description: 'Un château gonflable enchanté inspiré de l’univers Disney pour des fêtes féeriques !',
    prixDemiJournee: 17000,
    prixJournee: 24000,
  },
  {
    nom: 'Licorne',
    photo: 'images/chateaux/licorne.jpg',
    largeur: 5.5,
    longueur: 5.5,
    description: 'Un château gonflable féerique aux couleurs des licornes : rose, arc-en-ciel et paillettes pour une ambiance magique et rêveuse ! Parfait pour les anniversaires ou fêtes d’enfants qui adorent l’univers des licornes.',
    prixDemiJournee: 20000,
    prixJournee: 27000,
  },
  {
    nom: 'Moana',
    photo: 'images/chateaux/moana.jpg',
    largeur: 4.5,
    longueur: 4.5,
    description: 'Un château gonflable avec un grand toboggan inspiré de Vaïana pour une aventure inoubliable !',
    prixDemiJournee: 18000,
    prixJournee: 25000,
  },
  {
    nom: 'Océan',
    photo: 'images/chateaux/océan.jpg',
    largeur: 3.5,
    longueur: 3.5,
    description: 'Un château gonflable compact spécialement conçu pour les tout-petits sur le thème de l’océan !',
    prixDemiJournee: 16000,
    prixJournee: 23000,
  },
  {
    nom: 'Panda',
    photo: 'images/chateaux/panda.jpg',
    largeur: 7,
    longueur: 5,
    description: 'Un château gonflable sur le thème des pandas, conçu pour tous les âges avec ses décors rigolos et son grand toboggan.',
    prixDemiJournee: 24000,
    prixJournee: 32000,
  },
  {
    nom: 'Pirate',
    photo: 'images/chateaux/pirate.jpg',
    largeur: 4,
    longueur: 7,
    description: 'Embarquez à bord de notre château gonflable en forme de bateau pirate pour une aventure haute en couleur ! Avec son décor de navire, ses canons, son mât et son drapeau Jolly Roger, ce château est parfait pour tous les âges',
    prixDemiJournee: 24000,
    prixJournee: 32000,
  },
  {
    nom: 'Pompier',
    photo: 'images/chateaux/pompier.jpg',
    largeur: 6,
    longueur: 7,
    description: 'Découvrez notre château gonflable en forme de caserne de pompiers, complet avec son camion de pompier intégré !',
    prixDemiJournee: 25000,
    prixJournee: 35000,
  },
  {
    nom: 'Robot',
    photo: 'images/chateaux/robot.jpg',
    largeur: 6.5,
    longueur: 6.5,
    description: 'Plongez dans un monde high-tech avec notre château gonflable doté d’un robot géant !',
    prixDemiJournee: 23000,
    prixJournee: 30000,
  },
  {
    nom: 'Truck',
    photo: 'images/chateaux/truck.jpg',
    largeur: 4,
    longueur: 7,
    description: 'Découvrez notre château gonflable en forme de Monster Truck pour une expérience de jeu extrême !',
    prixDemiJournee: 24000,
    prixJournee: 32000,
  },
  {
    nom: 'Safari',
    photo: 'images/chateaux/safari.jpg',
    largeur: 6,
    longueur: 6,
    description: 'Un château gonflable spécialement conçu pour les tout-petits (1-4 ans) sur le thème des animaux du safari ! Avec ses basses parois, ses formes arrondies et ses décors mignons (lions, girafes, éléphants, zèbres), les enfants exploreront la savane en toute sécurité',
    prixDemiJournee: 22000,
    prixJournee: 29000,
  },
  {
    nom: 'Vaiana',
    photo: 'images/chateaux/vaiana.jpg',
    largeur: 4,
    longueur: 7,
    description: 'Inspiré de l’univers de Vaïana, ce château gonflable géant combine un mur d’escalade (pour gravir les vagues comme Maui !) et un long toboggan',
    prixDemiJournee: 24000,
    prixJournee: 32000,
  },
];
